import { dispatchSignals } from "@prelude.so/js-sdk/signals";
import { PRELUDE_SDK_KEY } from "../constants.js";

export default () => ({
  dispatchId: "",

  init() {
    this.gatherSignals();
  },

  async gatherSignals() {
    try {
      this.dispatchId = await dispatchSignals(PRELUDE_SDK_KEY);
    } catch (error) {
      // Fail open — verification should still proceed without browser signals.
      this.dispatchId = "";
    }
  },
});
